import Carousel from "../Common/Carousel"
import FirearmCard from "../Common/FirearmCard"
import { Link, usePage } from "@inertiajs/react"

/**
 * The Sell/Consign banner that used to open this section is now the sell half
 * of HomepageHero.
 * CTABannerV2 still serves the listing pages, so it stays (FAL-227).
 */
export const EndingSoon = () => {
    const { ending_soon: items } = usePage().props

    return (
        <div className="flex flex-col items-center w-full gap-8 pt-10 pb-8 overflow-hidden lg:pt-12 lg:pb-0">
            <h2 className="-mb-6 text-2xl font-bold text-black lg:text-3xl">
                Used Guns Auctions
            </h2>
            <h3 className="flex items-center gap-2 -mb-8 text-xl font-bold text-[#800020] lg:text-3xl">
                Ending Soon - Don't Miss Out!
            </h3>

            <div className="w-full lg:w-[1228px] h-full">
                <Carousel
                    items={items}
                    itemTemplate={FirearmCard}
                    multipleRows={true}
                    dotSpacing="lg:bottom-[-80%]"
                />
            </div>

            <Link href={"/auctions"}>
                <div className="mt-2 sm:ms-5 lg:ms-0 flex h-[48px] w-[225px] text-neutral-50 rounded-md transition-colors bg-[#800020] hover:bg-maroon-light items-center justify-center">
                    View More
                </div>
            </Link>
        </div>
    )
}
